import { __module as lib } from '../../../_virtual/index69.js';

/**
 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
 *
 * The decorator may be used on classes or methods
 * ```
 * @autobind
 * class FullBound {}
 *
 * class PartBound {
 *   @autobind
 *   method () {}
 * }
 * ```
 */

var hasRequiredLib;

function requireLib () {
	if (hasRequiredLib) return lib.exports;
	hasRequiredLib = 1;
	(function (module, exports) {

		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = autobind;

		function autobind() {
		  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		    args[_key] = arguments[_key];
		  }

		  if (args.length === 1) {
		    return boundClass.apply(undefined, args);
		  } else {
		    return boundMethod.apply(undefined, args);
		  }
		}

		/**
		 * Use boundMethod to bind all methods on the target.prototype
		 */
		function boundClass(target) {
		  // (Using reflect to get all keys including symbols)
		  var keys = undefined;
		  // Use Reflect if exists
		  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
		    keys = Reflect.ownKeys(target.prototype);
		  } else {
		    keys = Object.getOwnPropertyNames(target.prototype);
		    // use symbols if support is provided
		    if (typeof Object.getOwnPropertySymbols === 'function') {
		      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
		    }
		  }

		  keys.forEach(function (key) {
		    // Ignore special case target method
		    if (key === 'constructor') {
		      return;
		    }

		    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);

		    // Only methods need binding
		    if (typeof descriptor.value === 'function') {
		      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
		    }
		  });
		  return target;
		}

		/**
		 * Return a descriptor removing the value and returning a getter
		 * The getter will return a .bind version of the function
		 * and memoize the result against a symbol on the instance
		 */
		function boundMethod(target, key, descriptor) {
		  var fn = descriptor.value;

		  if (typeof fn !== 'function') {
		    throw new Error('@autobind decorator can only be applied to methods not: ' + typeof fn);
		  }

		  // In IE11 calling Object.defineProperty has a side-effect of evaluating the
		  // getter for the property which is being replaced. This causes infinite
		  // recursion and an "Out of stack space" error.
		  var definingProperty = false;

		  return {
		    configurable: true,
		    get: function get() {
		      if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
		        return fn;
		      }

		      var boundFn = fn.bind(this);
		      definingProperty = true;
		      Object.defineProperty(this, key, {
		        value: boundFn,
		        configurable: true,
		        writable: true
		      });
		      definingProperty = false;
		      return boundFn;
		    }
		  };
		}
		module.exports = exports['default']; 
	} (lib, lib.exports));
	return lib.exports;
}

export { requireLib as __require };
